type Props = { prompt: string; disabled: boolean; onClick: () => void };

export default function PromptSuggestion({ prompt, disabled, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-ph-capture-attribute-action="send_ai_prompt_suggestion"
      className="border border-neutral-light rounded-full px-3 py-2 text-xs hover:bg-action-hover active:bg-action-selected cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {prompt}
    </button>
  );
}
